import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common-services/common.service';


@Component({
  selector: 'app-interest-dialog',
  templateUrl: './interest-dialog.component.html',
  styleUrls: ['./interest-dialog.component.scss']
})
export class InterestDialogComponent implements OnInit {
  interestsList: any[] = [];

  constructor(private dialogRef: MatDialogRef<InterestDialogComponent>, private service: CommonService, @Inject(MAT_DIALOG_DATA) public data: any ) { }

  closeDialog(isTrue: Boolean) {
    this.dialogRef.close({isTrue:isTrue, data:this.interestsList});
  }
  ngOnInit() {
    if(this.data){
      this.interestsList = this.data.data;
    }
  }



  toggleValueCheck(ev:any, values:any){
    console.log(ev);
    values.isChecked = ev.target.checked
    console.log(this.interestsList)
  }
}
